import { GET_ASSESSMENTS } from "constants/assessments";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_ASSESSMENTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
